module.exports = "<div class=\"footer z-index-2\">\n  <div class=\"col-12\">\n    <p> &copy; MaterialTube</p>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main